export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/inspection.7423b42b.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};